/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cdo_Qr_PrintInputs */

const vi_cdo_qr_print = /** @type {(inputs: Cdo_Qr_PrintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In phiếu giao`)
};

/**

* @param {Cdo_Qr_PrintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cdo_qr_print = /** @type {((inputs?: Cdo_Qr_PrintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cdo_Qr_PrintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cdo_qr_print(inputs)
});